export default function createVideoAttachmentStyle() {
  return {};
}
